webpackJsonp([162898551421021],{

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _icons = __webpack_require__(48);
	
	var _content = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _content.Paper,
	    null,
	    _react2.default.createElement(
	      "section",
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "No lambdas here..."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          "em",
	          null,
	          "Okay"
	        ),
	        ", there is one: ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "\u03BB"
	        ),
	        " - just for you!"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If you looked for something, and you have not found it - ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/#contact" },
	          "let us know."
	        )
	      ),
	      _react2.default.createElement(
	        _content.ParagraphAlignedToRight,
	        null,
	        "Now let's go ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/" },
	          "back"
	        ),
	        ". ",
	        _react2.default.createElement(_icons.HomeIcon, null)
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-458beb5d63971f12ed9b.js